module.exports = __webpack_public_path__ + "img/item4-5.11469ca7.png";